import { render, staticRenderFns } from "./FeesMethodology.vue?vue&type=template&id=06325ff4&"
import script from "./FeesMethodology.vue?vue&type=script&lang=js&"
export * from "./FeesMethodology.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports